import axios from 'axios';
import qs from 'qs';
const service = axios.create({
    baseURL: 'https://ysapi.smartfuns.com/', // api的base_url
    baseURL: 'https://www.xinsec.com.cn/18081/', // api的base_url
    timeout: 50000                 // 请求超时时间
});
// service.interceptors.response.use(response => {
//     if (response.data.code == -20) {
//         store.state.notLogin = Math.round(Math.random() * 1000)
//     }
//     return response
// })
service.interceptors.request.use(
	config => {
		// do something before request is sent
		console.log("config");
		console.log(config);
		//var params = new Object();
		//params['data'] = aecEncode(config.data);
		//config.data = qs.stringify(params);
		//config.params = params;
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)
export default service   


// WEBPACK FOOTER //
// ./src/api/fetch.js